import { useCallback, useEffect } from "react";
import type { BookingResponseData } from "../../../lib/@types";

type Options = {
  onBookingPayload: (data: BookingResponseData) => void;
};

/**
 * Listens for Trips.ng (or compatible) postMessage payloads after iframe booking completes.
 */
export function useTripsIframeMessages({ onBookingPayload }: Options): void {
  const handleMessage = useCallback(
    (message: MessageEvent) => {
      try {
        const isTripOrigin = message.origin.includes("trip") ||
          (process.env.NODE_ENV === "development" && message.origin.includes("localhost"));
        if (!isTripOrigin) {
          return;
        }
        const data = JSON.parse(message.data) as BookingResponseData;
        onBookingPayload(data);
      } catch {
        // ignore malformed messages
      }
    },
    [onBookingPayload]
  );

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);
}
